// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/trip/destination.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_annotations } from "../core/annotations_pb";
import { file_proto_model_entity_geo } from "../entity/geo_pb";
import { file_proto_model_entity_geoentity } from "../entity/geoentity_pb";
import { file_proto_model_entity_image } from "../entity/image_pb";
import { file_proto_model_trip_advisories } from "./advisories_pb";
import { file_proto_model_trip_entry_requirements } from "./entry_requirements_pb";
import { file_proto_model_trip_highlights } from "./highlights_pb";

/**
 * Describes the file proto/model/trip/destination.proto.
 */
export const file_proto_model_trip_destination = /*@__PURE__*/
  fileDesc("CiJwcm90by9tb2RlbC90cmlwL2Rlc3RpbmF0aW9uLnByb3RvEgZjYXJtZW4iwgQKC0Rlc3RpbmF0aW9uEhYKDmRlc3RpbmF0aW9uX2lkGAEgASgJEg8KB3RyaXBfaWQYAiABKAkSDQoFdGl0bGUYAyABKAkSEAoIbG9jYXRpb24YBCABKAkSDQoFZW1vamkYBSABKAkSEwoLZGVzY3JpcHRpb24YBiABKAkSJQoGaW1hZ2VzGAcgASgLMhUuY2FybWVuLkltYWdlQ2Fyb3VzZWwSIgoIdmlld3BvcnQYCCABKAsyEC5jYXJtZW4uVmlld3BvcnQSEAoIdGltZXpvbmUYCSABKAkSMQoKYWR2aXNvcmllcxgKIAEoCzIdLmNhcm1lbi5EZXN0aW5hdGlvbkFkdmlzb3JpZXMSNQoSZW50cnlfcmVxdWlyZW1lbnRzGAsgASgLMhkuY2FybWVuLkVudHJ5UmVxdWlyZW1lbnRzEi4KCmdlb19lbnRpdHkYDCABKAsyGi5jYXJtZW4uR2VvRW50aXR5UmVmZXJlbmNlEikKBnN0YXR1cxgNIAEoDjIZLmNhcm1lbi5EZXN0aW5hdGlvblN0YXR1cxJIChdwZXJzb25hbGl6ZWRfaGlnaGxpZ2h0cxgOIAEoCzIhLmNhcm1lbi5QZXJzb25hbGl6ZWRIaWdobGlnaHRMaXN0QgSItRgCEisKB2NyZWF0ZWQYDyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiwKCG1vZGlmaWVkGBAgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCp7ChFEZXN0aW5hdGlvblN0YXR1cxIiCh5ERVNUSU5BVElPTl9TVEFUVVNfVU5TUEVDSUZJRUQQABIgChxERVNUSU5BVElPTl9TVEFUVVNfQ0FORElEQVRFEAESIAocREVTVElOQVRJT05fU1RBVFVTX0NPTkZJUk1FRBACQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM", [file_google_protobuf_timestamp, file_proto_model_core_annotations, file_proto_model_entity_geo, file_proto_model_entity_geoentity, file_proto_model_entity_image, file_proto_model_trip_advisories, file_proto_model_trip_entry_requirements, file_proto_model_trip_highlights]);

/**
 * Describes the message carmen.Destination.
 * Use `create(DestinationSchema)` to create a new message.
 */
export const DestinationSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_destination, 0);

/**
 * Describes the enum carmen.DestinationStatus.
 */
export const DestinationStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_trip_destination, 0);

/**
 * @generated from enum carmen.DestinationStatus
 */
export const DestinationStatus = /*@__PURE__*/
  tsEnum(DestinationStatusSchema);

